var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "*navigation-improvements",
    stroke: "none",
    strokeWidth: 1,
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proposal-Success---Go-to-Insurance-Consent-Portal---Menu",
    transform: "translate(-1347.000000, -33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(648.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.937851,46.0002838 L723.896387,37.062581 L723.896387,37.0625809 C724.713327,36.2456415 724.713327,34.9211156 723.896387,34.1041804 C723.079448,33.2872411 721.754922,33.2872411 720.937987,34.1041807 L712.000284,43.0627173 L703.062581,34.1041807 L703.062581,34.1041809 C702.245642,33.2872415 700.921116,33.2872415 700.104181,34.1041806 C699.287241,34.9211199 699.287241,36.2456458 700.10418,37.062581 C700.10418,37.062581 700.10418,37.062581 700.10418,37.062581 L709.062717,46.0002838 L700.10418,54.9379867 L700.10418,54.9379866 C699.287241,55.748255 699.281833,57.0673683 700.0921,57.8843035 C700.09611,57.8883467 700.100137,57.8923734 700.10418,57.8963836 L700.10418,57.8963835 C700.914449,58.7133229 702.233562,58.7187313 703.050497,57.9084638 C703.05454,57.9044536 703.058567,57.9004268 703.062577,57.8963836 L712.00028,48.937847 L720.937983,57.8963836 L720.937983,57.8963836 C721.748251,58.713323 723.067364,58.7187314 723.8843,57.9084638 C723.888343,57.9044537 723.89237,57.9004269 723.89638,57.8963837 L723.89638,57.8963836 C724.713319,57.0861153 724.718728,55.767002 723.90846,54.9500668 C723.90445,54.9460236 723.900423,54.9419969 723.89638,54.9379867 L714.937851,46.0002838 Z",
    id: "Fill"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerClose);
export default __webpack_public_path__ + "static/media/hamburger-close.546f2ca395f8652c3c795419b58b18b6.svg";
export { ForwardRef as ReactComponent };